import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/index.js";
import { LogoImg } from "../LogoImg/index.js";
import { P } from "../Text/index.js";
import { merchDisplayPillVariants } from "./MerchDisplayPill.variants.js";
const MerchDisplayPill_MerchDisplayPill = /*#__PURE__*/ forwardRef(function({ discountText, brandName, brandImage, theme = 'neutral', emphasis = 'bold', alignment = 'left', textSize = 'heading6', bleed = 'centered' === alignment ? 0 : 4, copyable = false, className, style, ...rest }, ref) {
    const isCopyable = copyable && 'string' == typeof discountText;
    const handleCopyClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        if ('string' != typeof discountText) return;
        navigator.clipboard?.writeText?.(discountText)?.catch(()=>{});
    };
    const hasInvalidBleed = 'centered' === alignment && 0 !== bleed;
    if (hasInvalidBleed && 'production' !== process.env.NODE_ENV) console.warn('[MerchDisplayPill] `bleed` is ignored when `alignment="centered"` (no edge to anchor to). Remove `bleed` or change alignment to `left`/`right`.');
    const { root, brand, discount } = merchDisplayPillVariants({
        theme,
        emphasis,
        alignment,
        textSize
    });
    let brandNode = null;
    if (null != brandImage) brandNode = /*#__PURE__*/ jsx(LogoImg, {
        src: brandImage,
        alt: brandName ?? '',
        size: textSize,
        clearSpace: false,
        colorMode: 'bold' === emphasis ? 'white' : 'original',
        className: brand()
    });
    else if (null != brandName) brandNode = /*#__PURE__*/ jsx(P, {
        textStyle: textSize,
        className: brand(),
        children: brandName
    });
    const effectiveBleed = hasInvalidBleed ? 0 : bleed;
    const bleedStyle = 'centered' === alignment ? void 0 : {
        '--merch-pill-bleed': `calc(var(--spacing) * ${effectiveBleed})`
    };
    return /*#__PURE__*/ jsxs("div", {
        ref: ref,
        style: void 0 === bleedStyle ? style : {
            ...bleedStyle,
            ...style
        },
        className: cn(root(), className),
        ...rest,
        children: [
            brandNode,
            discountText && /*#__PURE__*/ jsx(P, {
                className: cn(discount(), isCopyable && 'cursor-copy select-all'),
                onClick: isCopyable ? handleCopyClick : void 0,
                title: isCopyable ? 'Click to copy' : void 0,
                children: discountText
            })
        ]
    });
});
export { MerchDisplayPill_MerchDisplayPill as MerchDisplayPill };
